// Customers
import CreateCustomerPopupModal from './customers/createPopup';
import CreateEditCustomerModal from './customers/createAndEdit';
import CustomerSearchModal from './customers/search';
import DeleteCustomerModal from './customers/delete';
// Customers Terms
import CustomerTermsModal from './customerTerms';
// Vendors
import CreateVendorPopupModal from './vendors/createPopup';
import CreateEditVendorModal from './vendors/createAndEdit';
import DeleteVendorModal from './vendors/delete';
// Vendor Terms
import VendorTermsModal from './vendorTerms';
// Orders
import CreateOrderPopupModal from './orders/createPopup';
import CreateEditOrderModal from './orders/createAndEdit';
import DeleteOrderModal from './orders/delete';
import OrderSearchModal from './orders/search';
// PurchaseOrders
import CreatePurchaseOrderPopupModal from './purchaseOrders/createPopup';
import CreateEditPurchaseOrderModal from './purchaseOrders/createAndEdit';
import DeletePurchaseOrderModal from './purchaseOrders/delete';
import PurchaseOrderSearchModal from './purchaseOrders/search';
// Packing Slips
import CreatePackingSlipPopupModal from './packingSlips/createPopup';
import CreateEditPackingSlipModal from './packingSlips/createAndEdit';
// Invoices
import CreateInvoicePopupModal from './invoices/createPopup';
import CreateEditInvoiceModal from './invoices/createAndEdit';
// Items
import ItemSearchModal from './items/search';
import CreateItemPopupModal from './items/createPopup';
import CreateEditItemModal from './items/createAndEdit';
import DeleteItemModal from './items/delete';
// Settings
import SettingModal from './settings';
import AltShipMethodsModal from './altShipMethods';
import ShipMethodsModal from './shipMethods';
import SystemNumbersModal from './systemNumbers';
import VendorSearchModal from './vendors/search';
import SalesTaxSearchModal from './salesTax/search';
// Account
import AccountModal from './account';
// Account
import AuditHistoryModal from './auditHistory';

/**
 * Modals
 * This should be the single mounting point for all modals. All modals should have a redux slice.
 * The purpose is so that all modals are mounted only once and can be opended from anywhere in the app.
 */
export const Modals = () => {
  return (
    <>
      {/* Customers */}
      <CreateCustomerPopupModal />
      <CreateEditCustomerModal />
      <CustomerSearchModal />
      <DeleteCustomerModal />
      {/* Customers Terms */}
      <CustomerTermsModal />
      {/* Vendors */}
      <CreateVendorPopupModal />
      <CreateEditVendorModal />
      <VendorSearchModal />
      <DeleteVendorModal />
      {/* Vendor Terms */}
      <VendorTermsModal />
      {/* Orders */}
      <CreateOrderPopupModal />
      <CreateEditOrderModal />
      <DeleteOrderModal />
      <OrderSearchModal />
      {/* Purchase Orders */}
      <CreatePurchaseOrderPopupModal />
      <CreateEditPurchaseOrderModal />
      <DeletePurchaseOrderModal />
      <PurchaseOrderSearchModal />
      {/* Packing Slips */}
      <CreatePackingSlipPopupModal />
      <CreateEditPackingSlipModal />
      {/* Invoices */}
      <CreateInvoicePopupModal />
      <CreateEditInvoiceModal />
      {/* Items */}
      <CreateEditItemModal />
      <CreateItemPopupModal />
      <ItemSearchModal />
      <DeleteItemModal />
      {/* Settings */}
      <AltShipMethodsModal />
      <ShipMethodsModal />
      <SystemNumbersModal />
      <SalesTaxSearchModal />
      <SettingModal />
      {/* Account */}
      <AccountModal />
      {/* Audit History */}
      <AuditHistoryModal />
    </>
  );
};

export default Modals;
